var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ArrowLeftIcon } from '@marketing-icons';
import { clsx } from 'clsx';
function BackButton(_a) {
    var onClick = _a.onClick;
    var flexStyle = 'flex justify-center items-center';
    var borderStyle = 'rounded-full border-2 border-shoe';
    var spacingAndSizing = 'w-12 md:w-15 h-12 md:h-15';
    return (_jsx("button", __assign({ className: clsx(flexStyle, borderStyle, spacingAndSizing), "aria-label": "Go back button", onClick: onClick }, { children: _jsx(ArrowLeftIcon, { className: "text-icon-dark size-6 md:size-7" }) })));
}
export default BackButton;
